import { useEffect } from "react";
import useCheckoutStore, { checkoutActions } from "../../store/checkout";
import { useCheckoutData } from "../../hooks/use-checkout-data";
import useXHR from "../../hooks/use-xhr";
import l10n from "../../lib/l10n";
import { useAppDialog } from "../../store/app-dialog";
import { orderDialogProxy } from "./CheckoutOrderDialog";
import { responseHasErrors } from "../../lib/utils";
// import { globalHandler } from "./custom-cropper/cropper-store";
// import { zoomDialogProxy } from "./checkout__delete/dialog-zoom";
// import { OrderDialogSuccess } from "./checkout__delete/dialog-success";
// import { OrderDialogError } from "./checkout__delete/dialog-error";
import { useAppDrawer } from "../../store/app-drawer";
import CheckoutQuoteForm from "./CheckoutQuoteForm";
import { CheckoutSuccessDialog } from "./CheckoutSuccessDialog";
import { useCropperStore } from "../../store/cropper/cropper-store";
import { CheckoutZoomDialog } from "./CheckoutZoomDialog";
import { ZOOM_MAX_RATIO } from "../../lib/constants";
import { CheckoutErrorDialog } from "./CheckoutErrorDialog";
import useTotals from "@src/v3.0.0/hooks/use-totals";
import CheckoutMinimumChargeDialog from "./CheckoutMinimumChargeDialog";
import { CROPPER_META_KEY, URL_PARAM_PRESET } from "@src/var";

const wp_ajax_hook = {
  [checkoutActions.CHECKOUT_ACTION_BUY_NOW]: 'woocommerce_add_to_cart',
  [checkoutActions.CHECKOUT_ACTION_ADD_TO_CART]: 'woocommerce_add_to_cart',
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER]: 'wppr_process_loggedin_order',
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER_SIMPLE]: 'wppr_process_loggedin_order',
  [checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE]: 'wppr_process_quote',
  [checkoutActions.CHECKOUT_ACTION_DEBUG]: 'wppr_ajax_order_debug',
  [checkoutActions.CHECKOUT_ACTION_EMAIL_PREVIEW]: 'wppr_email_preview'
};

const wp_nonce = {
  [checkoutActions.CHECKOUT_ACTION_BUY_NOW]: 'wc_nonce',
  [checkoutActions.CHECKOUT_ACTION_ADD_TO_CART]: 'wc_nonce',
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER]: 'wc_checkout_nonce',
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER_SIMPLE]: 'wc_checkout_nonce',
  [checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE]: 'wc_checkout_nonce',
  [checkoutActions.CHECKOUT_ACTION_DEBUG]: 'wc_nonce',
  [checkoutActions.CHECKOUT_ACTION_EMAIL_PREVIEW]: 'wc_nonce',
};

export const additional_ajax_data = {
  [checkoutActions.CHECKOUT_ACTION_BUY_NOW]: {},
  [checkoutActions.CHECKOUT_ACTION_ADD_TO_CART]: {},
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER]: {
    // wc checkout required fields
    'billing_first_name': l10n?.u_billing_first_name,
    'billing_last_name': l10n?.u_billing_last_name,
    'billing_country': l10n?.u_billing_country,
    'billing_address_1': l10n?.u_billing_address_1,
    'billing_postcode': l10n?.u_billing_postcode,
    'billing_city': l10n?.u_billing_city,
    'billing_state': l10n?.u_billing_state,
    'billing_phone': l10n?.u_billing_phone,
    'billing_email': l10n?.u_billing_email,
    'payment_method': 'cod',
    // others
    'order_comments': '',
    'terms': false,
    'createaccount': false,
    'wppr_order_factory': 'wallpaper',
  },
  [checkoutActions.CHECKOUT_ACTION_CREATE_ORDER_SIMPLE]: {
    // wc checkout required fields
    'billing_first_name': l10n?.u_billing_first_name,
    'billing_last_name': l10n?.u_billing_last_name,
    'billing_country': l10n?.u_billing_country,
    'billing_address_1': l10n?.u_billing_address_1,
    'billing_postcode': l10n?.u_billing_postcode,
    'billing_city': l10n?.u_billing_city,
    'billing_state': l10n?.u_billing_state,
    'billing_phone': l10n?.u_billing_phone,
    'billing_email': l10n?.u_billing_email,
    'payment_method': 'cod',
  },
};

class CheckoutError extends Error {
  constructor(message, customData) {
    super(message); 
    this.name = this.constructor.name;
    this.customData = customData;
  }
}

function Checkout() {
  const action = useCheckoutStore(s => s.action);
  const {payload, setProcessing, dispatch: dispatchCheckoutAction} = useCheckoutStore();
  const cropper = useCropperStore(s => s.getCropper());
  const checkoutData = useCheckoutData();
  const {invokeDialog} = useAppDialog();
  const {invokeDrawer} = useAppDrawer();
  const http = useXHR();
  const totalsHook = useTotals();

  useEffect(() => {
    if (action) {
      console.log('checkout action', action);
      const ajaxData = { 
        ...checkoutData.get(wp_ajax_hook[action], l10n[wp_nonce[action]]), 
        ...payload,
        ...additional_ajax_data[action]
      };
      
      console.log('payload', ajaxData, 'data', action);

      (async () => {

        switch(action) {
          case checkoutActions.CHECKOUT_ACTION_CREATE_ORDER:
            try {

              /**
               * il dialog ordine deve essere mostrato se:
               * - è richiesto esplicitamente (l10n.ui_order_notes_display === yes)
               * - non esiste una email (anche se l10n.ui_order_notes_display === no)
               *   quindi se non esiste un utente (checkout per guest)
               */
              const orderData = await invokeDialog(orderDialogProxy, {
                title: 'Crea un preventivo'
              });
              ajaxData.terms = orderData.terms;
              ajaxData.order_comments = orderData.order_comments;
              ajaxData.wppr_order_email = orderData.wppr_order_email;
            } catch(e) {
              return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_COMPLETE, e);
            }
            break;

          case checkoutActions.CHECKOUT_ACTION_CREATE_QUOTE:
            try {
              /**
               * drawer con il form informazioni del cliente, nome, cognome, città, provincia ecc
               */
              const quoteData = await invokeDrawer(
                ({resolve, reject}) => <CheckoutQuoteForm resolve={resolve} reject={reject}/>, 
                { title: 'Crea Preventivo' }
              );
              ajaxData.form = quoteData;
              console.log('quoteData', quoteData);
            } catch(e) {
              return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_COMPLETE, e);
            }
            break;
          default:
            break;
        }
        
        /** ------------------ Zoom Warning -------------------------- */
        try {
          
          if (cropper.preset.zoom >= ZOOM_MAX_RATIO) {
            await invokeDialog(
              (resolve, reject) => <CheckoutZoomDialog resolve={resolve} reject={reject} />,
              { title: 'Zoom Eccessivo' }
            );
          }
        } catch(e) {
          return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_COMPLETE, e);
        }

        /** ------------------ Minimum Charge Warning -------------------------- */
        try {
          
          if (totalsHook.getSquareMeters() < l10n.p_sqmt_minimum_charge) {
            await invokeDialog(
              (resolve, reject) => <CheckoutMinimumChargeDialog resolve={resolve} reject={reject} />, 
              { title: `Minimo Fatturabile: ${l10n.p_sqmt_minimum_charge}MQ` }
            );
            ajaxData[CROPPER_META_KEY].accept_minimum_charge = true;
          }
        } catch(e) {
          return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_COMPLETE, e);
        }

        /** ---------------- Process checkout ajax data ---------------- */
        try {
          setProcessing(true);
          console.log('SEND', ajaxData);
          const response = await http.post(ajaxData);
          console.log('RES', response);

          if (responseHasErrors(response)) {
            throw new CheckoutError("Checkout error", response);
          }
          
        } catch(error) {
          console.log('Error', error.customData);
          // write error log
          // const debugData = checkoutData.debug(
          //   wp_ajax_hook[checkoutActions.CHECKOUT_ACTION_DEBUG],
          //   wp_nonce[checkoutActions.CHECKOUT_ACTION_DEBUG],
          //   {
          //     action: action.toString(),
          //     message: `errore checkout: ${ajaxData.product_id} ${action.toString()}`
          //   }
          // );
          // await http.post(debugData);
          
          // chiama il dialog di errore
          const message = <>
            <p>Impossibile creare ordine. <br /> Si è pregati di contattare il servizio clienti.</p>
            {error.customData?.data?.messages && <div dangerouslySetInnerHTML={{ __html: error.customData.data.messages }} />}
          </>;
          await invokeDialog(<CheckoutErrorDialog message={message} />);
          
          return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_ERROR, error);
        }

        console.log('checkout success -> ', action);
        
        // chiama il dialog di successo
        await invokeDialog(
          <CheckoutSuccessDialog action={action} />, {
            title: 'Successo'
        });

        return dispatchCheckoutAction(checkoutActions.CHECKOUT_ACTION_COMPLETE);
      })();
    } else {
      setProcessing(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);
};

export default Checkout;